import { NgModule } from '@angular/core';
import { IssuerEditComponent } from './issuer-edit/issuer-edit.component';
import { IssuerListComponent } from './issuer-list/issuer-list.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    IssuerEditComponent,
    IssuerListComponent
  ],
})
export class IssuerModule { }
